import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import { Grid } from 'semantic-ui-react';
import { vpmobile } from '../../../utils';
import './PageBody.scss';
const PageBodyContext = createContext({ reversed: false });
const PageBodySectionMain = ({ children, className }) => {
    return (_jsx("div", { className: "page-body-main", children: children }));
};
const PageBodySectionAside = ({ children, className }) => {
    return (_jsx("div", { className: "page-body-aside", children: children }));
};
const PageBodySection = ({ children, className, darkBlue = false, lightBlue = false }) => {
    var _a, _b;
    const { reversed } = useContext(PageBodyContext);
    const mainx = (_a = React.Children.toArray(children).find(child => React.isValidElement(child) &&
        child.type === PageBodySectionMain)) !== null && _a !== void 0 ? _a : null;
    const asidex = (_b = React.Children.toArray(children).find(child => React.isValidElement(child) &&
        child.type === PageBodySectionAside)) !== null && _b !== void 0 ? _b : null;
    const clsxSec = ['page-body-section',
        darkBlue ? 'dark-blue' : lightBlue ? 'light-blue' : '', className !== null && className !== void 0 ? className : ''].join(' ');
    const twoColumn = !!(mainx && asidex);
    const [widthMain, widthAside] = (twoColumn ? [10, 6] : [16, 0]);
    const [clsMain, clsAside] = (twoColumn ? ['main padded', 'aside padded'] : ['main', 'aside']);
    const gridColMain = _jsx(Grid.Column, { className: clsMain, width: widthMain, children: mainx });
    const gridColAside = twoColumn ? _jsx(Grid.Column, { className: clsAside, width: widthAside, children: asidex }) : null;
    const clsxPageDim = [
        'page-dim',
        'no-gutter'
    ].join(' ');
    return (_jsx("section", { className: clsxSec, children: _jsx("div", { className: clsxPageDim, children: _jsxs(Grid, { stackable: true, reversed: reversed ? 'mobile' : undefined, children: [gridColMain, gridColAside] }) }) }));
};
export const PageBody = ({ children, className, reversed }) => {
    const [mobileViewport, setMobileViewport] = useState(vpmobile());
    useEffect(() => {
        const testViewportWidth = () => { setMobileViewport(vpmobile()); };
        window.addEventListener('onscroll', testViewportWidth);
        return () => {
            window.removeEventListener('onscroll', testViewportWidth);
        };
    }, []);
    return (_jsx(PageBodyContext.Provider, { value: { reversed: reversed !== null && reversed !== void 0 ? reversed : false }, children: _jsx("div", { className: "page-body", children: _jsx("div", { className: "page-body-content", children: children }) }) }));
};
PageBodySection.Main = PageBodySectionMain;
PageBodySection.Aside = PageBodySectionAside;
PageBody.Section = PageBodySection;
